export namespace Login {
  export const href = (): string =>
    pipe(
      window.location.hostname.includes("staging") ||
        window.location.hostname.includes("localhost")
        ? "staging-app"
        : "app",
      (subdomain) => `https://${subdomain}.estrack.com/login`
    );

  export const hrefWithLogout = (): string => `${href()}?logout=true`;
  export const hrefWithRedirect = (): string =>
    `${href()}?fwd=${window.location.href}`;
}
